import { useRef, useState } from 'react';
import { getContext } from '@/context';
import useMount from './useMount';

type OpenCallback = () => void | (() => void);

const useOpen = (callback?: OpenCallback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const cleanupRef = useRef<(() => void) | null>(null);

  const [state, setState] = useState(false);

  useMount(() => {
    const unsubscribe = getContext().handlers.onOpen(() => {
      setState(true);
      if (callbackRef.current) {
        const cleanup = callbackRef.current();
        if (typeof cleanup === 'function') {
          cleanupRef.current?.();
          cleanupRef.current = cleanup;
        }
      }
    });

    return () => {
      cleanupRef.current?.();
      cleanupRef.current = null;
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  });

  return state;
};

export default useOpen;
